import { render, staticRenderFns } from "./TableOrderComponent.vue?vue&type=template&id=784a8706&scoped=true"
import script from "./TableOrderComponent.vue?vue&type=script&lang=js"
export * from "./TableOrderComponent.vue?vue&type=script&lang=js"
import style0 from "./TableOrderComponent.vue?vue&type=style&index=0&id=784a8706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a8706",
  null
  
)

export default component.exports